import { DomainEvent } from "@/domains/events"

import { TokenStore } from "./token-store"

export class TokenAddedEvent extends DomainEvent {
  static readonly TYPE = "token.added"
  readonly type = TokenAddedEvent.TYPE
  constructor(public readonly token: TokenStore) {
    super()
  }
}

export class TokenApprovalCompletedEvent extends DomainEvent {
  static readonly TYPE = "token.approval-completed"
  readonly type = TokenApprovalCompletedEvent.TYPE
  constructor(
    public readonly groupId: string,
    public readonly tokenAddress: string,
    public readonly spenderAddress: string,
    public readonly amount: bigint,
    public readonly transactionHash: string,
  ) {
    super()
  }
}
